import { HTMLAttributes, PropsWithChildren } from "react";
import "./RatingTile.scss";

interface RatingTileProps extends HTMLAttributes<HTMLDivElement>, PropsWithChildren {
	compact?: boolean;
}

export default function RatingTile({ compact, className, children, ...rest }: RatingTileProps) {
	const classes = ["rating-tile"];
	if (compact) classes.push("compact");
	if (className) classes.push(className);

	return (
		<div className={classes.join(" ")} {...rest}>
			{children}
		</div>
	);
}
